import { render, staticRenderFns } from "./todoCatalogo.vue?vue&type=template&id=43798c2c"
import script from "./todoCatalogo.vue?vue&type=script&lang=js"
export * from "./todoCatalogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports